import React from "react";
import mainLogo from "../assets/logo-main.png";

const Header = () => {
  return (
    <div className="header">
      <picture className="logo-picture">
        <img src={mainLogo} alt="Stories Through The Lens" />
      </picture>
    </div>
  );
};

export default Header;
